export function normalizeCandidateLog(item) {
    if (typeof item.acao !== 'string') return item;
    const start = item.acao.indexOf('{');
    const end = item.acao.lastIndexOf('}');
    if (start < 0 || end < start) return item;
    try {
        const details = JSON.parse(item.acao.slice(start, end + 1));
        if (!details || typeof details !== 'object' || Array.isArray(details)) return item;
        return {
            ...item,
            acao: item.acao.slice(0, start).replace(/[\s.:]+$/, ''),
            mensagem: typeof details.mensagem === 'string' ? details.mensagem : item.mensagem,
            detalhes: details,
        };
    } catch (_) {
        return item;
    }
}
